import { render, staticRenderFns } from "./triatlon.vue?vue&type=template&id=0c91d8f5"
import script from "./triatlon.vue?vue&type=script&lang=js"
export * from "./triatlon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports